import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UiServiceWebSession } from '@drct-web-apps/ui-services';
import { ReplaySubject, takeUntil } from 'rxjs';



@Component({
  selector: 'ui-web-banner',
  templateUrl: './ui-web-banner.component.html',
  imports: [ CommonModule ]
})
export class UiWebBannerComponent implements OnInit, OnDestroy {
  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public bannerImage: string[] = [];
  constructor(private readonly session: UiServiceWebSession) { }

  ngOnInit(): void {
    this.bannerImage = [];
    this.setBannerImage();
    this.session.sessionReady
                .pipe(takeUntil(this.destroyed$))
                .subscribe((ready: boolean) => {
                  if(ready) {
                    this.setBannerImage();
                  }
                });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  private setBannerImage() {
    this.bannerImage = [];
    const images = this.session.webConfig?.banner_imgs ?? "";
    if(images) {
      const imgPath = 'assets/uploads/banners/';
      images.split(',').forEach((img: string) => {
        this.bannerImage.push(imgPath.concat(img.trim()));
      });
    }

    const eventImages = this.session.webConfig?.banner_events ?? "";
    if(eventImages) {
      const imgPath = 'assets/uploads/img/';
      eventImages.split(',').forEach((img: string) => {
        this.bannerImage.push(imgPath.concat(img.trim()));
      });
    }
  }
}